import { render } from "./CoBrandSplit.vue?vue&type=template&id=352cb26b&scoped=true"
import script from "./CoBrandSplit.vue?vue&type=script&lang=js"
export * from "./CoBrandSplit.vue?vue&type=script&lang=js"

import "./CoBrandSplit.vue?vue&type=style&index=0&id=352cb26b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352cb26b"]])

export default __exports__